/* eslint-disable no-inline-comments */
export const IndustrialFeeConcept = {
  fixedFee: 17, //CARGO FIJO
  commertialization: 18, //CARGO COMERCIALIZACION CON ST
  consumption: 31, //CONSUMO
  contribution: 37, //CONTRIBUCION
  supply: 200, //SUMINISTRO DE GAS
  transport: 204 //TRANSPORTE DE GAS
};

export const IndustrialConceptText = {
  [IndustrialFeeConcept.fixedFee]: 'Cargo fijo',
  [IndustrialFeeConcept.commertialization]: 'Costo de comercialización',
  [IndustrialFeeConcept.distribution]: 'Cargo por distribución',
  [IndustrialFeeConcept.consumption]: 'Cargo variable',
  [IndustrialFeeConcept.contribution]: 'Contribución',
  [IndustrialFeeConcept.supply]: 'Suministro de gas natural',
  [IndustrialFeeConcept.transport]: 'Transporte'
};

export const HeliosConcepts = {
  supply: 'supply',
  transport: 'transport',
  distribution: 'distribution',
  commercialization: 'commercialization'
};

export const HeliosConceptsText = {
  [HeliosConcepts.supply]: 'Suministro',
  [HeliosConcepts.transport]: 'Transporte',
  [HeliosConcepts.distribution]: 'Distribución',
  [HeliosConcepts.commercialization]: 'Comercialización'
};
